module.exports = __webpack_public_path__ + "static/img/dyInfo01.cd75d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/dyInfo01.jpg
// module id = ZRBw
// module chunks = 0